import Modal, { ModalAction, ModalBody, ModalHead } from '@/components/@base/modal';

import useCommonModalStore from '@/store/common-modal-store';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router';

export default function CommonModal() {
  const {
    setShow,
    show,
    Head,
    Body,
    Action,
    DialogProps,
    DialogPanelProps,
    onDemandClose,
    noBackDrop,
    darkBackDrop,
    center,
    grayScaleBackDrop,
    dialogPanelClassName,
  } = useCommonModalStore();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate()
  function resetIpgStatus() {
    if(searchParams.has('mt') && searchParams.has('pgc')){
      navigate(`/?pgc=${searchParams.get('pgc')}`)
    }
    if(searchParams.has('IPGStatus') && searchParams.has('pgc')){
      navigate(`/?pgc=${searchParams.get('pgc')}`)
    }
  }
  function onClose() {
    onDemandClose && setShow(false);
    resetIpgStatus()
  }

  return (
    <Modal
      className='bg-grayDark-900'
      show={show}
      noBackDrop={noBackDrop}
      grayScaleBackDrop={grayScaleBackDrop}
      center={center}
      onClose={onClose}
      darkBackDrop={darkBackDrop}
      dialogPanelClassName={dialogPanelClassName}
      dialogPanelProps={DialogPanelProps || undefined}
      dialogProps={DialogProps || undefined}
    >
      {Head && (
        <ModalHead isCustomHead>
          <Head />
        </ModalHead>
      )}
      <ModalBody className='flex flex-col gap-2.5'>
        <Body />
      </ModalBody>
      {Action && (
        <ModalAction>
          <Action />
        </ModalAction>
      )}
    </Modal>
  );
}
